<template>
  <div class="service">
    <div v-html="agree"></div>
  </div>
</template>

<script>
export default {
  name: 'service',
  data(){
    return{
      agree:null
    }
  },
  created () {
    this.getAgree()
  },
  methods:{
    getAgree(){
      this.$http.get('/api/getAgreement?type=2').then((res) => {
        this.agree = res.data.data.content
      })
    }
  }
}
</script>

<style scoped lang="less">
.service {
  width: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;

  div {
    margin-top: 10%;
    margin-bottom: 20%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/police.vue